module.exports = __webpack_public_path__ + "media/promo/courses/images/s6-f7f8a5d389eb8f5951d1062f0587d9ba.jpg";